var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrewsorCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#191A23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6414 20.5018C30.2262 20.5018 29.8182 20.5268 29.4173 20.5805C24.7931 21.1317 21.1246 24.7967 20.577 29.4209C20.5268 29.7788 20.5054 30.1439 20.5018 30.5125V30.7738C20.4982 30.7309 20.4982 30.6843 20.4982 30.6414C20.4982 30.2262 20.4732 29.8182 20.4195 29.4173C19.8683 24.7931 16.2033 21.1317 11.5827 20.5805C11.1818 20.5268 10.7738 20.5018 10.3586 20.5018C10.7738 20.5018 11.1818 20.4767 11.5827 20.423C16.2069 19.8719 20.0258 16.2212 20.4195 11.5827C20.4588 11.1174 20.4911 10.1868 20.5018 9.72155C20.5125 9.29205 20.5018 8 20.5018 8C20.4087 8 20.3121 8 20.219 8.00358C13.5476 8.15032 8.15032 13.5512 8.00358 20.2226C8 20.3157 8 20.4087 8 20.5018C8 20.5948 8 20.6879 8.00358 20.781C8.15032 27.4488 13.5476 32.8497 20.219 32.9964C20.3121 33 20.4087 33 20.5018 33C20.5948 33 20.6843 33 20.7774 32.9964C27.4488 32.8533 32.8497 27.4524 32.9964 20.781C33 20.6879 33 20.5948 33 20.5018H30.6414Z",
    fill: "#00DF67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5018 30.5125C20.4982 30.5555 20.4982 30.5984 20.4982 30.6414C20.4982 30.6843 20.4982 30.7309 20.5018 30.7738V30.5125Z",
    fill: "#00DF67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9714 18.0573C30.7486 18.0573 33 15.8059 33 13.0286C33 10.2514 30.7486 8 27.9714 8C25.1941 8 22.9427 10.2514 22.9427 13.0286C22.9427 15.8059 25.1941 18.0573 27.9714 18.0573Z",
    fill: "#00DF67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewsorCd);
export default __webpack_public_path__ + "static/media/crewsor-cd.884f4285d00cffc2b5b53708b9045129.svg";
export { ForwardRef as ReactComponent };